<template lang="pug">
    div.customer-area
        customer-search(
            @customer:set="handleSearch($event)"
            v-model="searchModal"
            v-if="searchModal"
        )
          template(slot="toolbar-tail")
            .d-flex.pr-3.pt-3
              v-switch(
                label="Traer datos faltantes desde S.I.I."
                v-model="completeFromSii"
                )
        CoreBusinessModal(
          v-if="customerData.id"
          :customer="customerData"
          v-model="showCoreBusinesModal"
          :core-business-list="coreBusinessList"
          require-auth
          @customer:edited="updateCustomer"
          )
        v-card.ma-1.customer-card.pa-4.d-flex.align-center
            v-form(ref="form")    
                v-layout(row wrap)
                    v-flex.xs12
                        v-btn(
                            :color="colors.primary"
                            dark
                            @click="searchModal = true"
                            ) 
                            v-icon(left) search
                            span Buscar
                        v-btn(
                            :color="colors.secondary"
                            dark
                            @click="handleCreateButton()"
                            ) 
                            v-icon(left) add
                            span Crear
                    v-flex.xs12
                        rut-input.mx-3.mt-5(
                            ref="rut"
                            v-model="rut"
                            @valid="onValidRut($event)"
                            @keydown="handleKeydown($event)"
                            v-bind="{label:'RUT'}"
                            v-if="editable"
                            )
                        v-text-field.mx-3(
                            v-model="rut"
                            label="RUT"
                            readonly
                            :mask="rutMask(rut)"
                            v-else
                        )
                    v-flex.xs12.md6
                        v-text-field.mx-3(
                            maxlength="80"
                            :readonly="!editable"
                            label="Nombre/Nombre de Fantasía"
                            :rules="rules.personName"
                            v-model="personName"
                            @input="updateStateOnInput()"
                            )
                    v-flex.xs12.md6
                        v-text-field.mx-3(
                            maxlength="80"
                            :readonly="!editable"
                            label="Razón Social"
                            :rules="rules.businessName"
                            v-model="businessName"
                            @input="updateStateOnInput()"
                            )
                    v-flex.xs12.md6
                        //v-text-field.mx-3(
                            maxlength="80"
                            :readonly="!editable"
                            label="Giro"
                            :rules="rules.coreBusiness"
                            v-model="coreBusiness"
                            @input="updateStateOnInput()"
                            ) 
                        v-autocomplete.mx-3(
                            v-if="createMode"
                            label="Giro"
                            multiple
                            chips
                            deletable-chips
                            :items="coreBusinessList"
                            v-model="createCoreBusiness"
                            item-text="core_business"
                            item-value="id"
                            ) 
                        template(v-else)
                            .d-flex
                                v-autocomplete.mx-3(
                                    label="Giro"
                                    :items="customerData ? customerData.g_core_business_sii : []"
                                    v-model="selectedCoreBusines"
                                    item-text="core_business"
                                    item-value="id"
                                    ) 
                                v-btn.secondary(
                                  :disabled="!customerData.id"
                                  style="width: 150px; max-width: 150px; min-width: 150px;"
                                  @click="showCoreBusinesModal = true"
                                  large
                                  ) 
                                  v-icon(left) edit
                                  span Giros
                    v-flex.xs12.md6(v-if="!editable")
                        v-select.mx-3(
                            ref="dir2"
                            v-model="activeOffice"
                            :items="addressesList"
                            label="Dirección"
                            @change="setActiveOffice($event)"
                            )
                    template(v-else)
                            v-flex.xs6
                                v-text-field.mx-3(
                                    ref="email"
                                    v-model="emailField"
                                    maxlength="80"
                                    :readonly="!editable"
                                    label="Email"
                                    :rules="rules.email"
                                    @input="editable ? updateStateOnInput() : ''"
                                    )
                            v-flex.xs6
                                v-text-field.mx-3(
                                    maxlength="50"
                                    v-model="addressField"
                                    :readonly="!editable"
                                    label="Dirección"
                                    :rules="rules.address"
                                    @input="editable ? updateStateOnInput() : ''"
                                    ) 
                            v-flex.xs6
                                v-autocomplete.mx-3(
                                    v-model="selectedCommune" 
                                    item-text="name" 
                                    item-value="id" 
                                    :items="communes" 
                                    label="Comuna" 
                                    :rules="[mixRules.required]" 
                                    @change="updateStateOnInput()"
                                    )
                            v-flex.xs6
                                v-autocomplete.mx-3(
                                    v-model="selectedCity" 
                                    item-text="name" 
                                    item-value="id" 
                                    :items="cities" 
                                    label="Ciudad" 
                                    :rules="[mixRules.required]" 
                                    @change="updateStateOnInput()"
                                    )
                            v-flex.xs6
                                v-text-field.mx-3(
                                    maxlength="50"
                                    v-model="zone"
                                    :readonly="!editable"
                                    label="Sector"
                                    @input="editable ? updateStateOnInput() : ''"
                                    ) 
                    v-flex.xs12.md6
                    //-     v-text-field.mx-3(
                    //-         maxlength="15" 
                    //-         v-model="phone" 
                    //-         :readonly="!editable" 
                    //-         label="Teléfono" 
                    //-         :rules="rules.phone" 
                    //-         @input="editable ? updateStateOnInput() : ''"
                    //-         mask="#########"
                    //-         prefix="+56"
                    //-         ) 
                    //- v-flex.xs12.md6
                    //-     v-text-field.mx-3(
                    //-         maxlength="15" 
                    //-         v-model="phone2" 
                    //-         :readonly="!editable" 
                    //-         label="Teléfono 2" 
                    //-         :rules="rules.phone" 
                    //-         @input="editable ? updateStateOnInput() : ''"
                    //-         mask="#########"
                    //-         prefix="+56"
                    //-         ) 
                    //- v-flex.xs12.md6
                    //-     v-text-field.mx-3(
                    //-         ref="email"
                    //-         v-model="email"
                    //-         maxlength="80"
                    //-         :readonly="!editable"
                    //-         label="Email"
                    //-         :rules="rules.email"
                    //-         @input="editable ? updateStateOnInput() : ''"
                    //-         )
                    v-flex.xs6
                    v-flex.xs6(
                        v-if="editable"
                        )
                        v-btn(
                            block
                            :color="colors.secondary"
                            dark
                            @click="handleCancel()"
                            :disabled="loadingSave"
                            :dark="!loadingSave"
                            outline
                            ) 
                            v-icon(
                                left
                                v-if="!loadingSave"
                                ) cancel
                            v-progress-circular.mr-4(
                                v-else
                                indeterminate
                                :color="colors.secondary"
                                size="25")
                            span CANCELAR
                    v-flex.xs6(
                        v-if="editable"
                        )
                        v-btn(
                            block
                            :color="colors.secondary"
                            dark
                            @click="handleSubmit()"
                            :disabled="loadingSave"
                            :dark="!loadingSave"
                            ) 
                            v-icon(
                                left
                                v-if="!loadingSave"
                                ) save
                            v-progress-circular.mr-4(
                                v-else
                                indeterminate
                                :color="colors.secondary"
                                size="25")
                            span (F1) GUARDAR
                    v-snackbar(
                        v-model="showSnack"
                        :color="snackColor"
                    ).pa-4
                        .d-flex(
                            style="justify-content: center; align-items: center;"
                        )
                            v-icon.mr-3 {{snackIcon}}
                            span.subheading(v-html="saveMessage")
</template>

<script>
import RUTInput from '@/components/RUTInput/RUTInput'
import InputValidations from '@/mixins/InputValidations'
import { mapGetters, mapActions, mapState } from 'vuex'
import CustomerSearch from '@/components/CustomerSearch/CustomerSearch'
import CustomerModel from '../../models/Sale/SlCustomer'
import { addRUTHyphen } from '../../services/RUTFormatter'
import { cloneDeep } from 'lodash'
import CoreBusinessModal from '../../components/CoreBusinessModal/CoreBusinessModal'
export default {
    name: 'customer-form',
    props: {},
    data: function() {
        return {
            completeFromSii: false,
            showCoreBusinesModal: false,

            rut: '',
            businessName: '',
            personName: '',
            coreBusiness: '',
            addressesList: [],
            editable: false,
            showMessage: false,
            offices: [],
            activeOffice: '',
            emailField: '',
            addressField: '',
            phoneField: '',
            selectedCommune: '',
            searchModal: false,
            loadingSave: false,
            saveMessage: '',
            showSnack: false,
            snackColor: '',
            savedCustomer: false,
            snackIcon: '',
            selectedCity: '',
            zone: '',
            phone2: '',

            createCoreBusiness: [],
        }
    },
    computed: {
        selectedCoreBusines: {
            get() {
                if (!this.customerData) return null
                return this.customerData.active_core_business_id
            },
            set(v) {
                let customerData = cloneDeep(this.customerData)
                customerData.active_core_business_id = v
                this.setCustomerData(customerData)
            },
        },
        ...mapGetters('TransactionModule', {
            activeTransaction: 'activeTransaction',
        }),
        ...mapState('CustomerModule', {
            customerData: 'customerData',
            createMode: 'createMode',
            activeOfficeID: 'activeOfficeID',
        }),
        ...mapState('SessionModule', {
            communes: 'communes',
            cities: 'cities',
            coreBusinessList: 'coreBusinessList',
        }),
        /**
         * @description
         */
        rules: function() {
            let rules = []
            if (this.activeTransaction.name == 'quotation') {
                rules = {
                    personName: [this.mixRules.required],
                    businessName: [],
                    coreBusiness: [],
                    address: [],
                    phone: [],
                    email: [this.mixRules.email],
                }
            }
            if (this.activeTransaction.name == 'invoice') {
                rules = {
                    personName: [this.mixRules.required],
                    businessName: [this.mixRules.required],
                    coreBusiness: [this.mixRules.required],
                    address: [this.mixRules.required],
                    phone: [],
                    email: [this.mixRules.email],
                }
            }
            return rules
        },
        customer: function() {
            return {
                rut: this.rut,
                businessName: this.businessName,
                personName: this.personName,
                coreBusiness: this.coreBusiness,
                branch_offices: this.editable
                    ? [
                          {
                              address: this.addressField,
                              phone: this.phoneField,
                              phone2: this.phone2,
                              email: this.emailField,
                              g_commune_id: this.selectedCommune,
                              default_branch_office: true,
                              city: this.selectedCity,
                              zone: this.zone,
                          },
                      ]
                    : null,
            }
        },
        address: {
            get() {
                if (this.editable) return this.addressField
                if (this.offices.length === 0) return ''
                let office = this.offices.find(
                    off => off.id === this.activeOffice
                )
                return office.address || ''
            },
            set(val) {
                this.addressField = val
            },
        },
        email: {
            get() {
                if (this.editable) return this.emailField
                if (this.offices.length === 0) return ''
                let office = this.offices.find(
                    off => off.id === this.activeOffice
                )
                return office.email || ''
            },
            set(val) {
                this.emailField = val
            },
        },
        phone: {
            get() {
                if (this.editable) return this.phoneField
                if (this.offices.length === 0) return ''
                let office =
                    this.offices.find(off => off.id === this.activeOffice) ||
                    this.offices[0]
                return office.phone || ''
            },
            set(val) {
                this.phoneField = val
            },
        },
    },
    methods: {
        rutMask(rut) {
            let mask = ''
            let num = rut.substring(0, rut.length - 1)
            num = num.split('').reverse()
            for (let i = 0; i < num.length; i++) {
                mask += '#'
                if ((i + 1) % 3 === 0) {
                    mask += '.'
                }
            }
            mask = mask
                .split('')
                .reverse()
                .join('')
            mask += '-n'
            return mask
        },
        handleCreateButton() {
            this.setCustomerData({})
            this.initData()
            this.editable = true
            this.toggleCreateMode(true)
            this.$refs.form.resetValidation()
            this.$nextTick(() => this.$refs.rut.focus())
        },
        test() {},
        ...mapActions('CustomerModule', {
            setCustomerData: 'setCustomerData',
            setCustomerID: 'setCustomerID',
            fetchCustomerData: 'fetchCustomerData',
            toggleCreateMode: 'toggleCreateMode',
            setAvailableDiscounts: 'setAvailableDiscounts',
            setActiveOffice: 'setActiveOffice',
            resetState: 'resetState',
        }),
        updateStateOnInput() {
            // if (!this.$refs.form.validate()) {
            //     this.setCustomerData({})
            //     return
            // }
            this.setCustomerData(this.customer)
        },
        initData: function() {
            this.rut = this.customerData.rut
            this.businessName = this.customerData.businessName
            this.personName = this.customerData.personName
            this.coreBusiness = this.customerData.coreBusiness
            let data = { ...this.customerData }
            if (this.customerData && this.customerData.branch_offices) {
                this.offices = [...this.customerData.branch_offices]
                if (this.activeOfficeID) {
                    this.activeOffice = this.activeOfficeID
                }
                // } else {
                //     this.activeOffice = office.id
                //     this.setActiveOffice(office.id)
                // }
                if (
                    !this.offices.some(
                        office => office.id === this.activeOffice
                    )
                ) {
                    this.activeOffice = this.offices[0].id
                    this.setActiveOffice(this.offices[0].id)
                }
                this.addressesList = this.customerData.branch_offices.map(
                    office => {
                        if (this.communes && this.communes.length > 0) {
                            return {
                                text:
                                    this.communes.find(
                                        com => com.id === office.g_commune_id
                                    ).name +
                                    ', ' +
                                    office.address,
                                value: office.id,
                            }
                        }
                    }
                )
            }
        },
        onValidRut: async function(event) {
            this.editable = true
            if (!event) {
                this.editable = true
                return
            }
            if (this.rut.length <= 7) {
                this.setCustomerData({})
                this.offices = []
                this.activeOffice = ''
                this.addressesList = []
                this.initData()
                return
            }
            if (this.createMode) {
                this.editable = true
            }
            const response = await this.fetchCustomerData({
                field: 'rut',
                value: this.rut,
                fetchMissingData: this.completeFromSii,
            })
            if (response === 'block') {
                this.snackColor = 'red darken-2'
                this.snackIcon = 'error'
                this.saveMessage = 'Cliente Bloqueado'
                this.showSnack = true
            }
            if (response) {
                this.editable = false
                this.initData()
                this.toggleCreateMode(false)
            } else {
                this.editable = true
                this.toggleCreateMode(true)
            }
        },
        handleKeydown(e) {
            switch (e.keyCode) {
                case 113:
                    this.searchModal = true
                    break

                default:
                    break
            }
        },
        async handleSearch(e) {
            let response = null
            try {
                response = await this.fetchCustomerData({
                    field: 'id',
                    value: e.id,
                    fetchMissingData: this.completeFromSii,
                })
            } catch (e) {
                this.snackColor = 'red darken-2'
                this.snackIcon = 'error'
                this.saveMessage =
                    e &&
                    e.response &&
                    e.response.data &&
                    e.response.data.message
                        ? e.response.data.message
                        : e
                this.showSnack = true
                return
            }
            if (response === 'block') {
                this.snackColor = 'red darken-2'
                this.snackIcon = 'error'
                this.saveMessage = 'Cliente Bloqueado'
                this.showSnack = true
            }
            if (response === true) {
                this.editable = false
                this.initData()
                this.toggleCreateMode(false)
                this.rut = this.customerData.rut
            } else {
                this.editable = true
                this.toggleCreateMode(true)
            }
        },
        async handleSubmit() {
            if (!this.$refs.form.validate()) {
                this.snackColor = 'red darken-2'
                this.saveMessage =
                    'Falta completar los campos marcados.' +
                    '<br>Si desea salir sin guardar los cambios, ' +
                    'pulse en el botón cancelar'
                this.snackIcon = 'error'
                this.showSnack = true
                return
            }
            let data = {
                rut: addRUTHyphen(this.rut),
                business_name: this.businessName,
                alias_name: this.personName,
                core_business: this.createCoreBusiness,
                email_collection: this.emailField
                    ? this.emailField
                    : 'clientefactura@agroplastic.cl',
                branch_offices: [
                    {
                        address: this.addressField,
                        phone: this.phoneField || null,
                        phone2: this.phone2 || null,
                        email: this.emailField
                            ? this.emailField
                            : 'clientefactura@agroplastic.cl',
                        g_commune_id: this.selectedCommune,
                        default_branch_office: true,
                        city: this.selectedCity || null,
                        zone: this.zone || null,
                    },
                ],
            }
            this.loadingSave = true
            let keyHandler = this.lockAllKeysInput()
            keyHandler.lock()
            let customer = new CustomerModel(data)
            customer
                .save()
                .then(res => {
                    /*
                    this.setCustomerID(res.customer_id)
                    this.saveMessage = 'Cliente registrado exitosamente'
                    this.snackColor = this.colors.success
                    this.snackIcon = 'info'
                    this.showSnack = true
                    keyHandler.unlock()
                    this.savedCustomer = true
                    this.loadingSave = false
                    */
                    this.resetState()
                    this.fetchCustomerData({
                        field: 'id',
                        value: res.customer_id,
                    })
                    this.editable = false
                    this.saveMessage = 'Cliente registrado exitosamente'
                    this.snackColor = this.colors.success
                    this.snackIcon = 'info'
                    this.showSnack = true
                    keyHandler.unlock()
                    this.savedCustomer = true
                    this.loadingSave = false
                    /*
                    setTimeout(() => {
                        this.$router.push('/')
                    }, 1000)
                    */
                })
                .catch(e => {
                    this.saveMessage = e.response.data.message
                    this.snackColor = 'red darken-2'
                    this.snackIcon = 'error'
                    this.showSnack = true
                    keyHandler.unlock()
                    this.loadingSave = false
                })
        },
        lockAllKeysInput() {
            let lockKeysHandler = e => {
                e.preventDefault()
                e.stopPropagation()
                e.stopImmediatePropagation()
            }
            return {
                lock: () => {
                    window.addEventListener('keydown', lockKeysHandler, false)
                    window.addEventListener('keyup', lockKeysHandler, false)
                },
                unlock: () => {
                    window.removeEventListener(
                        'keydown',
                        lockKeysHandler,
                        false
                    )
                    window.removeEventListener('keyup', lockKeysHandler, false)
                },
            }
        },
        handleCancel() {
            //this.toggleCreateMode(false)
            this.resetState()
            this.$router.push('/')
        },
        updateCustomer(customer) {
            this.fetchCustomerData({
                field: 'id',
                value: customer.id,
            })
            this.showCoreBusinesModal = false
        },
    },
    watch: {
        /**
         * @description
         */
        activeTransaction: function(newVal, oldVal) {
            this.$refs.form.validate()
            if (newVal.name == 'ticket') this.$router.replace('/')
        },
        rut: {
            handler: function(val, oldVal) {
                if (!val || val.length <= 7) {
                    this.setCustomerData({})
                    this.offices = []
                    this.activeOffice = ''
                    this.addressesList = []
                    this.initData()
                    return
                }
            },
        },
    },
    components: {
        'rut-input': RUTInput,
        'customer-search': CustomerSearch,
        CoreBusinessModal,
    },
    mixins: [InputValidations],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    created: function() {
        // this.resetState()
        if ([4, 5].includes(this.activeTransaction.id))
            this.$router.replace('/employee')
        if (this.activeTransaction.id === 1) this.$router.replace('/')
        this.initData()
    },
    mounted: function() {
        this.searchModal = true
        let looper = () => {
            this.$refs &&
            this.$refs.rut &&
            this.$refs.rut.$refs &&
            this.$refs.rut.$refs.rut
                ? this.$refs.rut.$refs.rut.focus()
                : setTimeout(looper, 100)
        }
        //looper()
    },
    beforeRouteLeave(to, from, next) {
        if (!this.createMode || (this.createMode && this.savedCustomer)) {
            next()
        } else {
            this.handleSubmit()
        }
    },
    watch: {
        searchModal(v) {
            if (!v) this.completeFromSii = false
        },
    },
}
</script>

<style lang="scss" scoped>
.customer-area {
    height: calc(100% - 9px);
    .customer-card {
        height: 100%;
        .notification-span {
            position: fixed;
            width: 100%;
            margin-left: -3em;
            margin-top: -17em;
        }
    }
}
</style>
